<h1 mat-dialog-title class="flex icon-with-text">
  <mat-icon svgIcon="download"></mat-icon>
  <span>Hent listen</span>
</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
@if (downloadUrl || error) {
  <div mat-dialog-content class="excel__download flex-wrap flex-wrap--center">
    @if (downloadUrl) {
      <div class="green align-center">
        <mat-icon svgIcon="checkmark" class="icon-48"></mat-icon>
        <br />
        <p>Listen er klar til download - Tak for din tålmodighed</p>
        @if (limit) {
          <p class="red">Excel begrænses til {{ limit }} rækker</p>
        }
      </div>
    }
    <div></div>
    @if (error) {
      <span class="red">{{ error }}</span>
    }
  </div>
} @else {
  <div mat-dialog-content>
    <p class="orange med-text align-center">
      <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
      <br />
      <span>Listen er ved at blive dannet - Vent venligst</span>
    </p>
    <div class="flex margin--top-l margin--bottom-l align-center">
      <div class="loading loading--dark"></div>
    </div>
  </div>
}

<div mat-dialog-actions class="align-center">
  @if (downloadUrl !== undefined) {
    <a mat-raised-button color="primary" mat-dialog-close="link" [href]="downloadUrl" [download]="fileName">
      Hent listen
    </a>
  }
  @if (downloadUrl === undefined) {
    <a mat-raised-button color="primary" mat-dialog-close="link">Luk</a>
  }
</div>
